/**
 * Helper function to determine if the current page is in admin context
 * @returns {boolean} True if current URL starts with /admin
 */
export function isAdmin() {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    return false
  }
  
  // Check if the current pathname starts with /admin
  return window.location.pathname.startsWith('/admin')
}

export default isAdmin